// extracted by mini-css-extract-plugin
module.exports =  {"button":"CommboxButton-CommboxButton-button-fc610f0a"};